import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { TarotContext } from '../context/TarotContext';
import '../styles/HomePage.css';
import SEO from '../components/SEO';

function HomePage() {
  const navigate = useNavigate();
  const { user, logout } = useContext(AuthContext);
  const { setQuestion, clearReadingState } = useContext(TarotContext);
  const [questionInput, setQuestionInput] = useState('');

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const handleQuestionSubmit = (submittedQuestion) => {
    if (!submittedQuestion.trim()) {
      alert('Please enter a question');
      return;
    }

    // Clear previous reading state first
    clearReadingState();
    
    // Set the new question
    setQuestion(submittedQuestion);

    // Navigate to reading page
    navigate('/reading', {
      state: {
        question: submittedQuestion,
        step: 2
      },
      replace: true
    });
  };

  return (
    <>
      <SEO 
        title="Tarot Mágico | Consulta Gratis de Tarot Online"
        description="Realiza tu consulta de tarot gratis. Obtén respuestas claras sobre amor, trabajo y futuro con nuestras tiradas de tarot personalizadas."
        keywords="tarot gratis online, consulta tarot, tirada gratis, tarot español, lectura tarot"
      />
      <div className="home-page">
        <div className="logo-container">
          <h1 className="site-title">Místico Tarot</h1>
          {user && (
            <div className="user-info">
              <span className="welcome-user">Bienvenido, {user.name}</span>
              <button onClick={handleLogout} className="logout-button">
                Cerrar Sesión
              </button>
            </div>
          )}
        </div>
        
        <div className="content-container">
          <div className="welcome-section">
            <h2>Bienvenido a tu viaje espiritual</h2>
            <p className="intro-text">
              Descubre los misterios del tarot y recibe orientación para tu camino.
              Las cartas te ayudarán a encontrar claridad y perspectiva.
            </p>
            
            <form onSubmit={(e) => { e.preventDefault(); handleQuestionSubmit(questionInput); }} className="question-form">
              <div className="form-group">
                <label htmlFor="question">¿Qué te gustaría consultar al tarot?</label>
                <textarea
                  id="question"
                  value={questionInput}
                  onChange={(e) => setQuestionInput(e.target.value)}
                  placeholder="Escribe tu pregunta aquí..."
                  rows="3"
                  required
                />
              </div>
              
              <div className="action-buttons">
                <button type="submit" className="primary-button" disabled={!questionInput.trim()}>
                  Consultar Tarot
                </button>
              </div>
            </form>
            
            <div className="additional-links">
              <Link to="/prediccion-diaria" className="prediction-link">Predicción Diaria</Link>
            </div>
          </div>
          
          <div className="contact-info">
            <p>Contacto: <a href="mailto:hola@tarotmagico.xyz">hola@tarotmagico.xyz</a></p>
          </div>
        </div>
      </div>
    </>
  );
}

export default HomePage; 